<script setup>
import { onMounted, ref } from "vue";
import useFormGenerator from "./hooks/useFormGenerator";

const { route, designer, designerConfig, handleSave, queryFormById } =
  useFormGenerator();

const saveShow = ref(true);

onMounted(() => {
  if (route.query?.config) {
    const id = JSON.parse(route.query?.config).id;
    queryFormById(id);
    saveShow.value = JSON.parse(route.query?.config).type == "design";
  }
});
</script>

<template>
  <zh-table-page v-bind="{ title: '表单设计器' }">
    <template #header-btn> </template>
    <template #search></template>
    <template #table>
      <!-- <v-form-designer ref="designer" :designer-config="designerConfig">
        <template #customToolButtons>
          <el-button type="primary" link @click="handleSave()">保存</el-button>
        </template>
      </v-form-designer> -->
      <CustomFormDesigner ref="designer" :designer-config="designerConfig">
        <template #customToolButtons>
          <el-button type="primary" link @click="handleSave()" v-if="saveShow"
            >保存</el-button
          >
        </template>
      </CustomFormDesigner>
    </template>
  </zh-table-page>
</template>

<style scoped>
body {
  margin: 0; /* 如果页面出现垂直滚动条，则加入此行CSS以消除之 */
}

:deep(.main-header) {
  display: none;
}
</style>
